const empty = (value) => value == null || value === "" || value === "–";
const internal = /^(?:auditMutation|schemaId|projectId|employeeId|year|month|time|createdBy|updatedBy)$|(?:^| · )(?:.*-ID|approvedFromRequest|Från godkänt ärende|bookingId|originalEmployeeId|bookingUserId|requestId|id)$/;

// Convert stored field paths into short descriptions, including older events.
export function simpleAuditChanges(entry) {
  if (entry.category === "Pass" && ["created", "deleted"].includes(entry.action)) return [];
  const result = [];
  const intervals = new Map();
  for (const change of entry.changes || []) {
    const parts = change.field.split(" · ");
    const leaf = parts[parts.length - 1];
    if (empty(change.before) && change.after === "Nej") continue;
    if (["Anställd", "employee"].includes(change.field) && (entry.changes || []).some(({field}) => field.startsWith("Anställda · "))) continue;
    if (internal.test(change.field) || [change.before, change.after].every((value) => empty(value) || value === "Tom lista")) continue;
    const typeIndex = parts.findIndex((part) => ["Raster", "Övertid", "Frånvaro"].includes(part));
    if (typeIndex !== -1 && parts.length > typeIndex + 2) {
      if (leaf === "Hela passet" && (parts[typeIndex] === "Raster" || change.after !== "Ja")) continue;
      const key = parts.slice(0, typeIndex + 2).join(" · ");
      let group = intervals.get(key);
      if (!group) {
        group = {field: key, changes: [], type: parts[typeIndex], person: parts[0] === "Anställda" ? parts[1] : "",
          label: parts[typeIndex + 1]};
        intervals.set(key, group);
        result.push(group);
      }
      group.changes.push({...change, leaf});
      continue;
    }
    const label = parts.filter((part) => part !== "Anställda" && !/^Rad \d+$/.test(part)).join(": ");
    if (parts[0] === "Anställda" && leaf === "Namn" && (empty(change.before) || empty(change.after))) {
      result.push({field: label, text: `${empty(change.after) ? change.before : change.after} ${empty(change.after) ? "togs bort från" : "lades till på"} passet.`});
    } else {
      result.push({...change, field: label});
    }
  }
  return result.map((item) => {
    if (!item.changes) return item;
    const changes = item.changes;
    const added = changes.every((change) => empty(change.before));
    const removed = changes.every((change) => empty(change.after));
    const time = (side) => {
      const start = changes.find((change) => change.leaf === "Starttid")?.[side];
      const end = changes.find((change) => change.leaf === "Sluttid")?.[side];
      return [!empty(start) && `starttid ${start}`, !empty(end) && `sluttid ${end}`].filter(Boolean).join(", ");
    };
    const type = {Raster: "Rast", Övertid: "Övertid", Frånvaro: "Frånvaro"}[item.type];
    const name = /^Rad \d+$/.test(item.label) ? "" : ` (${item.label})`;
    const prefix = `${item.person ? `${item.person}: ` : ""}${type}${name}`;
    const verb = added ? "tillagd" : removed ? "borttagen" : "ändrad";
    const before = time("before");
    const after = time("after");
    const detail = added ? after : removed ? before : before || after ? `innan ändring ${before || "–"}; efter ändring ${after || "–"}` : "";
    const other = changes.filter(({leaf}) => !["Starttid", "Sluttid"].includes(leaf)).map((change) => {
      if (empty(change.before)) return `${change.leaf.toLowerCase()}: ${change.after}`;
      if (empty(change.after)) return `${change.leaf.toLowerCase()} borttagen`;
      return `${change.leaf.toLowerCase()}: innan ${change.before}, efter ${change.after}`;
    });
    return {field: item.field, text: `${prefix} ${verb}${detail ? `, ${detail}` : ""}${other.length ? `; ${other.join("; ")}` : ""}.`};
  });
}
